import { Link } from 'react-router-dom';
import type { NewsItem } from '@/types/media';

interface NewsCardProps {
  item: NewsItem;
  variant?: 'default' | 'compact';
}

export default function NewsCard({ item, variant = 'default' }: NewsCardProps) {
  if (variant === 'compact') {
    return (
      <Link
        to={`/news/${item.id}`}
        className="group flex items-start gap-3 py-3.5 border-b border-background-200/70 last:border-0"
      >
        <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-accent-500 shrink-0" />
        <div className="flex-1 min-w-0">
          <h4 className="text-sm text-foreground-800 leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors">
            {item.title}
          </h4>
          <div className="mt-1.5 flex items-center gap-3 text-xs text-foreground-400">
            <span className="font-label">{item.date}</span>
            <span className="px-2 py-0.5 rounded bg-secondary-100 text-secondary-700">{item.category}</span>
          </div>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/news/${item.id}`}
      className="group flex flex-col sm:flex-row gap-4 bg-background-50 border border-background-200/80 rounded-lg overflow-hidden hover:border-primary-300 transition-colors duration-300"
    >
      <div className="w-full sm:w-56 lg:w-64 shrink-0 aspect-[16/10] sm:aspect-auto sm:h-auto overflow-hidden bg-background-200">
        <img
          src={item.cover}
          alt={`${item.title} 配图`}
          title={`${item.title} - 夏目彩春影视资讯`}
          className="w-full h-full object-top object-cover transition-transform duration-700 group-hover:scale-105"
        />
      </div>
      <div className="p-4 md:p-5 flex flex-col flex-1">
        <div className="flex items-center gap-2.5 mb-2.5">
          <span className="px-2.5 py-1 rounded-md bg-accent-100 text-accent-700 text-xs">{item.category}</span>
          <span className="text-xs text-foreground-400 font-label">{item.date}</span>
        </div>
        <h3 className="font-heading font-bold text-base md:text-lg text-foreground-950 leading-snug group-hover:text-primary-600 transition-colors line-clamp-2">
          {item.title}
        </h3>
        <p className="mt-2 text-sm text-foreground-700 leading-relaxed line-clamp-2 flex-1">{item.summary}</p>
        <span className="mt-3 text-sm text-primary-600 flex items-center gap-1">
          阅读全文
          <i className="ri-arrow-right-line text-sm" />
        </span>
      </div>
    </Link>
  );
}